import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { AccesoUsuarioComponent } from './pages/acceso-usuario/acceso-usuario.component';
import { SolicitudUsuarioComponent } from './pages/solicitud-usuario/solicitud-usuario.component';
import { AccountRequestComponent } from './components/account-request/account-request.component';
import { ActivarUsuarioComponent } from './pages/activar-usuario/activar-usuario.component';
import { MatStepperModule } from '@angular/material/stepper';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { InitAppService } from './services/init-app.service';
import { HttpClientModule } from '@angular/common/http';
import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha';
import { environment } from '../environments/environment';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormatRutDirective } from './directives/format-rut.directive';
import { MessageComponent } from './components/message/message.component';
import { RutPipe } from './directives/rut.pipe';
import { PasswordRecoveryComponent } from './components/password-recovery/password-recovery.component';
import { RecuperarContrasenaComponent } from './pages/recuperar-contrasena/recuperar-contrasena.component';
import { ExitoReestablecerComponent } from './components/exito-reestablecer/exito-reestablecer.component';
import { ModalExitoComponent } from './components/modal-exito/modal-exito.component';
import { ModalRecuperarContrasenaComponent } from './components/modal-recuperar-contrasena/modal-recuperar-contrasena.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { InputPhoneDirective } from './directives/input-phone/input-phone.directive';
import { InputRutDirective } from './directives/input-rut/input-rut.directive';

export function initializeApp(initAppService: InitAppService) {
  return (): Promise<any> => {
    return initAppService.Init();
  };
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    AccesoUsuarioComponent,
    SolicitudUsuarioComponent,
    AccountRequestComponent,
    ActivarUsuarioComponent,
    FormatRutDirective,
    MessageComponent,
    RutPipe,
    PasswordRecoveryComponent,
    RecuperarContrasenaComponent,
    ExitoReestablecerComponent,
    ModalExitoComponent,
    ModalRecuperarContrasenaComponent,
    InputPhoneDirective,
    InputRutDirective
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    MatStepperModule,
    MatSnackBarModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    NgSelectModule,
    ModalModule.forRoot()
  ],
  providers: [{ provide: APP_INITIALIZER, useFactory: initializeApp, deps: [InitAppService], multi: true },
  {
    provide: RECAPTCHA_SETTINGS,
    useValue: { siteKey: environment.RECAPTCHA_KEY } as RecaptchaSettings,
  }],
  entryComponents: [
    ModalRecuperarContrasenaComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
